import {BaseContainerModel} from '../base-container.model';
import {
  bl_prt_printable_format_hdr_RowInterface,
  bl_prt_printable_format_hdr_RowClass,
  bl_prt_printable_format_ext_RowClass
} from '../../dbschema/index';

export class PrintableFormatContainerModel extends BaseContainerModel {
  bl_prt_printable_format_hdr: bl_prt_printable_format_hdr_RowInterface = new bl_prt_printable_format_hdr_RowClass();
  bl_prt_printable_format_exts: bl_prt_printable_format_ext_RowClass[] = [];
}
